import gql from 'graphql-tag';
import * as React from 'react';
import { useQuery } from 'react-apollo';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { LoadingContent, Layout, LayoutContent, Navigation } from '../../components';
import { MenusLanding, MenusLandingVariables } from './__generated__/MenusLanding';
import { Button } from 'react-bootstrap';
const MENUS_QUERY = gql`
  query MenusLanding($venueId: ID!) {
    menus(venueId: $venueId) {
      id
      name
    }
  }
`;

interface MenuLandingRouterParams {
  venueId: string;
}

type MenuLandingProps = RouteComponentProps<MenuLandingRouterParams>;

export const MenuLanding: React.FC<MenuLandingProps> = (props) => {
  const { venueId } = props.match.params;

  const { data, error } = useQuery<MenusLanding, MenusLandingVariables>(MENUS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      venueId,
    },
  });

  const createMenu = () => {};

  if (data?.menus.length === 0) {
    return (
      <Layout>
        <Navigation />
        <Layout.TopBar>
          <Layout.TopBar.Left>
            <Layout.TopBar.Title>My Menu</Layout.TopBar.Title>
          </Layout.TopBar.Left>
        </Layout.TopBar>
        <LayoutContent error={error} className='menu-container'>
          <div className='d-flex flex-column w-100 h-100 align-items-center justify-content-center fulfillment-centers-empty'>
            <p className='mt-4 mb-4 text-center'>Please create a menu</p>
            <Button type='button' color='primary' className='btn--rounded ps-4 pe-4' onClick={createMenu}>
              Create a Menu
            </Button>
          </div>
        </LayoutContent>
      </Layout>
    );
  } else if (data?.menus.length) {
    return <Redirect to={`/venue/${venueId}/menu/list/${data.menus[0].id}`} />;
  }

  return (
    <Layout>
      <Navigation />
      <Layout.TopBar>
        <Layout.TopBar.Left>
          <Layout.TopBar.Title>My Menu</Layout.TopBar.Title>
        </Layout.TopBar.Left>
      </Layout.TopBar>
      <LayoutContent error={error} className='menu-container'>
        <LoadingContent />
      </LayoutContent>
    </Layout>
  );
};
